export default __webpack_public_path__ + "static/media/peak-logo-black.8bdbb671.png";